module.exports = __webpack_public_path__ + "static/media/люкс 1.55966b07.jpg";